import { useAtom } from "jotai";
import { useEffect } from "react";
import { venueAssistantDockOpenAtom } from "@/store/atoms";
import { useSelectedVenue } from "@/hooks/useSelectedVenue";
import { chatAssistantEnabled } from "common/config";
import VenueAssistantTab from "./VenueAssistantTab";

/**
 * Ask AI panel docked over a page's map column (desktop/tablet). Drop this as a
 * sibling inside a `relative` map-sidebar container; it covers the map when open
 * and leaves the map mounted underneath (no reload). Open state is shared via
 * venueAssistantDockOpenAtom so the trigger (in VenueSheetContent) controls it.
 *
 * Mobile uses the full-screen overlay inside VenueSheetContent instead — this dock
 * only renders where a map column exists.
 */
function VenueAssistantMapDock() {
  const [isOpen, setIsOpen] = useAtom(venueAssistantDockOpenAtom);
  const { selectedVenue } = useSelectedVenue();

  // Close the dock whenever the selected venue changes or clears, so it never
  // lingers open across venues.
  const slug = selectedVenue?.business?.slug ?? null;
  useEffect(() => {
    setIsOpen(false);
  }, [slug, setIsOpen]);

  if (!chatAssistantEnabled || !isOpen || !selectedVenue || !slug) {
    return null;
  }

  return (
    <div
      id="venue-assistant-dock"
      className="absolute inset-0 z-30 bg-bg-brand-secondary-default border border-border-token-brand-minimal rounded-xl p-4 flex flex-col overflow-hidden"
    >
      <VenueAssistantTab
        venueSlug={slug}
        venueName={selectedVenue.name}
        onClose={() => setIsOpen(false)}
        closeVariant="x"
        hasAccessibilityData={(selectedVenue.reviewDetailsSubmitted ?? 0) > 0}
        hasOpeningHours={(selectedVenue.openingHours?.length ?? 0) > 0}
      />
    </div>
  );
}

export default VenueAssistantMapDock;
